/**
 * @brief 개인 정보 수집 동의 내용 modal
 * @details
 * @author hyekyoungKang
 * @date 2024-08-14
 * @version 0.0.1
 */

import React from "react";
import CommonModal from "./common/CommonModal";
import styles from "./TermsPrivacyModal.module.scss";

const TermsPrivacyModal = () => {
  return (
    <CommonModal
      btnTitle={"닫기"}
      btnWidth={"120px"}
      btnHeight="48px"
      padding={"4rem"}
    >
      <div className={styles.container}>
        <div className={styles.container__title}>
          <span className={styles.container__titleTxt}>
            개인 정보 수집 동의 내용
          </span>
        </div>
        <div className={styles.container__subTitle}>
          <span className={styles.container__subTitleTxt}>
            스마트 워크는 아래와 같이 개인 정보를 수집합니다.
          </span>
        </div>
        <div className={styles.container__content}>
          <ol className={styles.container__infoList}>
            <li>
              개인정보의 수집 및 이용 목적 <br></br>- 입주 문의에 대한 답변 및
              관련 정보 제공
            </li>
            <li>
              수집하는 개인정보 항목 <br></br>- 이름, 회사명, 연락처, 이메일
            </li>
            <li>
              개인정보의 수집 및 이용 목적 <br></br>- 수집일로부터 3년간 보관
            </li>
          </ol>
          <span className={styles.container__descTxt}>
            ※ 해당 동의를 거부할 수 있으나, 거부 시 서비스 이용에 제한이 있을 수
            있습니다.
          </span>
        </div>
      </div>
    </CommonModal>
  );
};

export default TermsPrivacyModal;
